//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "./Icon";
import vClickOutside from "v-click-outside";
import MattingBgReplacement from "./MattingBgReplacement";
// import MattingCrop from "./MattingCrop";
import MattingApp from "./MattingApp";

const { fsms } = window.MattingEngineModule;

export default {
  name: "MattingAdvancedToolbar",
  components: {
    Icon,
    MattingBgReplacement,
    // MattingCrop,
    MattingApp,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      isShowBgReplacement: true,
    };
  },
  computed: {
    // isShowBgReplacement() {
    //   return this.isShowPanel && this.state.value === "bgReplacement";
    // },
    // isShowCrop() {
    //   return this.isShowPanel && this.state.value === "crop";
    // },
    // isShowMove() {
    //   return this.isShowPanel && this.state.value === "move";
    // },
  },
  watch: {
    isShow(val) {
      if (val === false) {
        this.send("IDLE");
      }
    },
  },
  setup() {
    const { state, send } = fsms.getToolbarFsm();
    return {
      state,
      send,
    };
  },
  methods: {
    // showBgReplacement() {
    //   this.allowPanelShow(true);
    //   this.send("BACKGROUND");
    // },
    // showCrop() {
    //   this.allowPanelShow(true);
    //   this.send("CROP");
    // },
    // showMove() {
    //   this.allowPanelShow(true);
    //   this.send("MOVE");
    // },
    // showEditMore() {
    //   this.allowPanelShow(true);
    //   this.send("EDITMORE");
    // },
    // allowPanelShow(active) {
    //   this.isShowPanel = active;
    // },
  },
};
